export default function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={"relative overflow-hidden py-6 " + className} aria-hidden="true">
      <div className="gl-marquee-track">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 px-8 font-display text-[7vw] md:text-[6vw] leading-none whitespace-nowrap"
          >
            <span>{item}</span>
            <span className="w-2 h-2 rounded-full bg-[#C89B3C] inline-block shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
